'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$scope', '$rootScope', '$utils',
    function($scope, $rootScope, $utils) {
        $rootScope.title = 'Утвержденные проекты';

        $scope.openControlSidebar = $utils.openControlSidebar;
        $scope.hideFilters = hideFilters;

        $scope.oldFilters = [];
        $scope.filters = [];

        function hideFilters() {
            if ($scope.filters.length > 0) {
                $scope.oldFilters = $scope.filters;
                $scope.filters = [];
            } else {
                $scope.isSetFilters = false;
                $scope.filters = $scope.oldFilters;
            }
        }

        $scope.$watch('filters', function() {
            $scope.isSetFilters = $scope.filters.length > 0;
        });
    }];
